import api from "../../../api-client"
import { extra } from "../../../config"
import { OpenPlaidLinkArgs } from "./Plaid.types"

export async function openPlaidLinkSession({
  item_id,
  redirectPath,
  setIsFetching,
}: OpenPlaidLinkArgs): Promise<void> {
  const { hosted_link_url } = await api.getPlaidLinkToken(
    item_id,
    redirectPath ? `${extra.webappUrl}/${redirectPath}` : (window?.location?.href as string | undefined)
  )
  setIsFetching(false)
  if (hosted_link_url) {
    window.location.href = hosted_link_url
    return
  }
  throw new Error("Missing hosted link URL for web.")
}


